document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_LocalizationDrawer', () => {
    return {
      pendingCountry: null,
      pendingLocale: null,
      
      init() {
        // Detect if mobile or desktop and register accordingly
        const isMobile = window.innerWidth < 1024;
        const drawerType = isMobile ? 'leftDrawer' : 'rightDrawer';
        Alpine.store('modals').register('localization', drawerType);
        
        // Store initial values when drawer opens (desktop - right drawer)
        this.$watch('$store.modals.rightDrawer.contents', (value) => {
          if (value === 'localization') {
            this.storePendingValues();
          }
        });
        
        // Store initial values when drawer opens (mobile - left drawer)
        this.$watch('$store.modals.leftDrawer.contents', (value) => {
          if (value === 'localization') {
            this.storePendingValues();
          }
        });
        
        // Re-register on window resize to handle orientation changes
        window.addEventListener('resize', () => {
          const isMobile = window.innerWidth < 1024;
          const drawerType = isMobile ? 'leftDrawer' : 'rightDrawer';
          Alpine.store('modals').register('localization', drawerType);
        });
      },
      
      storePendingValues() {
        // Use setTimeout to ensure form is rendered after teleport
        setTimeout(() => {
          const isMobile = window.innerWidth < 1024;
          const formId = isMobile ? 'drawer-mobile-localization-form' : 'drawer-desktop-localization-form';
          const form = document.getElementById(formId);
          
          if (form) {
            const countryInput = form.querySelector('input[name="country_code"]');
            const localeInput = form.querySelector('input[name="locale_code"]');
            
            this.pendingCountry = countryInput ? countryInput.value : null;
            this.pendingLocale = localeInput ? localeInput.value : null;
          }
        }, 10);
      },
      
      confirmLocalization() {
        const isMobile = window.innerWidth < 1024;
        const formId = isMobile ? 'drawer-mobile-localization-form' : 'drawer-desktop-localization-form';
        const form = document.getElementById(formId);
        
        if (form) {
          const countryInput = form.querySelector('input[name="country_code"]');
          const localeInput = form.querySelector('input[name="locale_code"]');
          
          const currentCountry = countryInput ? countryInput.value : null;
          const currentLocale = localeInput ? localeInput.value : null;
          
          // Only submit if something has changed
          if (
            (currentCountry && currentCountry !== this.pendingCountry) ||
            (currentLocale && currentLocale !== this.pendingLocale)
          ) {
            form.submit();
          } else {
            // Nothing changed, just close the drawer
            Alpine.store('modals').close('localization');
          }
        }
      }
    };
  });
});